import React, { useState } from "react";
import { ProductConsumer } from "../../context";
import Title from "../Title";
import Product from "../Product";
import ProductFilter from "./ProductFilter";

export default function Products() {
  const [visible, setVisible] = useState(6);
  const showMoreProducts = () => {
    setVisible((oldValue) => oldValue + 3);
  };
  return (
    <ProductConsumer>
      {(value) => {
        const { filteredProducts } = value;
        return (
          <section className="py-5">
            <div className="container">
              {/* title */}
              <Title center title="our products" />
              {/* Product filter */}
              <ProductFilter />
              {/* total count */}
              <div className="row">
                <div className="col-10 mx-auto">
                  <h6 className="text-title">
                    total products : {filteredProducts.length}
                  </h6>
                </div>
              </div>
              {/* products */}
              <div className="row py-5">
                {filteredProducts.slice(0, visible).map((product) => {
                  return <Product key={product.id} product={product} />;
                })}
              </div>
              {visible >= filteredProducts.length ? null : (
                <div className="row">
                  <div
                    style={{ textAlign: "center" }}
                    className="col-10 mx-auto pt-3"
                  >
                    <button onClick={showMoreProducts} className="main-link">
                      show more
                    </button>
                  </div>
                </div>
              )}
            </div>
          </section>
        );
      }}
    </ProductConsumer>
  );
}
